import React, { Component } from 'react';
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import { BrowserRouter, Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import { firebase } from '../firebase';
import "../main.css";

export class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      imgUrl: '',
      isShowingModal: false,
      initialMapCenter: { lat: 8.980603, lng: 38.757759 }
    }
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.onMapClicked = this.onMapClicked.bind(this);
    this.updateMapCenter = this.updateMapCenter.bind(this);
  }

  componentWillMount() {
    this.updateMapCenter();
  }

  componentWillUnmount() {
    var self = this;
    window.removeEventListener("resize", self.updateMapCenter);
  }
  componentDidMount() {
    var self = this;
    let app = firebase.db.database().ref('/items');
    app.on('value', (snapshot) => {
      self.getFormattedData(snapshot.val());
    });
    window.addEventListener("resize", self.updateMapCenter);
  }

  updateMapCenter() {
    this.setState({
      initialMapCenter: { lat: 5.980603, lng: 38.757759 }
    });
  }

  getFormattedData(values) {
    let items = _.map(values, (val, key) => {
      return _.extend({}, { id: key }, val);
    });
    this.setState({
      items: items
    });
  }

  setCurrentMarkerInSession(props) {
    var item = {
      id: props.id,
      name: props.name,
      location: {
        lat: props.position.lat,
        lng: props.position.lng
      },
      description: props.description,
      date: props.date,
      address: props.address,
      imgUrl: props.imgUrl
    };
    window.localStorage.setItem("activeMarker", JSON.stringify(item));
    //this.props.setActiveMarker(item);
  }

  onMarkerClick(props, marker, e) {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
      imgUrl: props.imgUrl
    });
    this.setCurrentMarkerInSession(props);
  }

  onInfoWindowClose() {

  }

  onMapClicked(props) {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  }

  windowHasClosed() {
    this.setState({
      showingInfoWindow: false
    })
  }

  render() {
    var markers = this.state.items.map(item => {
      return (
        <Marker
          id={item.id}
          imgUrl={item.imgUrl}
          key={item.id}
          title={item.name}
          name={item.name}
          description={item.description}
          date={item.date}
          address={item.address}
          position={{ lat: item.position.lat, lng: item.position.lng }} onClick={this.onMarkerClick}
        />
      );
    });

    return (
      <div>
        <h1 style={{ fontSize: 28, fontWeight: 600 }}>Oromos killed by the Ethiopian government. Not.Just.A.Number</h1>
        <Map google={this.props.google} initialCenter={this.state.initialMapCenter}
          style={{ width: '100%', height: '100%', position: 'relative' }}
          className={'map'}
          zoom={7}>
          {markers}
          <InfoWindow
            marker={this.state.activeMarker}
            visible={this.state.showingInfoWindow}>
            <div class="card border border-primary" style={{ width: '18rem' }}>
              <img src={this.state.imgUrl} alt="" style={{ width: '18rem' }} />
              <div class="card-body">
                <p class="card-text"><span style={{ fontWeight: 500, fontSize: 14 }}>{this.state.selectedPlace.name}</span> was killed by the Ethiopian government on {this.state.selectedPlace.date}</p>
                <BrowserRouter>
                  <Link to='/view'><strong>Details</strong></Link>
                </BrowserRouter>
              </div>
            </div>
          </InfoWindow>
        </Map>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    items: state.itemReducer
  }
};

/*
const mapDispatchToProps = (dispatch) => {
  return{
      addItem: (item) => dispatch(addItem(item)),
      setActiveMarker: (activeMarker) => dispatch(setActiveMarker(activeMarker))
  }
};
*/
const MyMap = connect(mapStateToProps)(MapContainer);

export default withRouter(GoogleApiWrapper({
  apiKey: 'AIzaSyAQq4uTbHyrbDw9Lg1AwoGsCgyvWVQuOUo'
})(MyMap))


// WEBPACK FOOTER //
// ./src/components/MapContainer.js